import { 
  Smartphone, Shirt, Utensils, ShoppingBasket, Sparkles, Sofa, Wrench, MoreHorizontal
} from 'lucide-react';

// Categories with colors
export const categories = [
  { id: 'electronics', name: 'Electronics', short: 'Tech', icon: Smartphone, color: 'bg-blue-500', placeholder: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=800' },
  { id: 'fashion', name: 'Fashion', short: 'Fashion', icon: Shirt, color: 'bg-pink-500', placeholder: 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=800' },
  { id: 'food', name: 'Food & Dining', short: 'Food', icon: Utensils, color: 'bg-orange-500', placeholder: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800' },
  { id: 'groceries', name: 'Groceries', short: 'Grocery', icon: ShoppingBasket, color: 'bg-green-500', placeholder: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=800' },
  { id: 'health', name: 'Health & Beauty', short: 'Beauty', icon: Sparkles, color: 'bg-red-400', placeholder: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800' },
  { id: 'home', name: 'Home & Living', short: 'Home', icon: Sofa, color: 'bg-amber-500', placeholder: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800' },
  { id: 'services', name: 'Services', short: 'Service', icon: Wrench, color: 'bg-purple-500', placeholder: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800' },
  { id: 'other', name: 'Other', short: 'More', icon: MoreHorizontal, color: 'bg-gray-500', placeholder: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=800' }
];

// Offer Types with styling
export const offerTypes = [
  { id: 'Discount', name: 'Discount', emoji: '💸', color: 'bg-blue-100 text-blue-700 border-blue-200' },
  { id: 'Flat Off', name: 'Flat Off', emoji: '🏷️', color: 'bg-green-100 text-green-700 border-green-200' },
  { id: 'Up to % Off', name: 'Up to % Off', emoji: '📉', color: 'bg-purple-100 text-purple-700 border-purple-200' },
  { id: 'Buy 1 Get 1', name: 'Buy 1 Get 1', emoji: '🎁', color: 'bg-pink-100 text-pink-700 border-pink-200' },
  { id: 'Combo Offer', name: 'Combo Offer', emoji: '🔥', color: 'bg-red-100 text-red-700 border-red-200' },
  { id: 'Cashback', name: 'Cashback', emoji: '💰', color: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  { id: 'Limited Time Offer', name: 'Limited Time Offer', emoji: '⏳', color: 'bg-yellow-100 text-yellow-700 border-yellow-200' },
  { id: 'Flash Sale', name: 'Flash Sale', emoji: '⚡', color: 'bg-amber-100 text-amber-700 border-amber-200' },
  { id: 'Weekend Offer', name: 'Weekend Offer', emoji: '🌟', color: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
  { id: 'Festive Offer', name: 'Festive Offer', emoji: '🎉', color: 'bg-orange-100 text-orange-700 border-orange-200' },
  { id: 'New Customer Offer', name: 'New Customer Offer', emoji: '🆕', color: 'bg-cyan-100 text-cyan-700 border-cyan-200' },
  { id: 'Free Delivery', name: 'Free Delivery', emoji: '🚚', color: 'bg-teal-100 text-teal-700 border-teal-200' },
  { id: 'Free Trial', name: 'Free Trial', emoji: '✨', color: 'bg-violet-100 text-violet-700 border-violet-200' },
  { id: 'Grand Opening', name: 'Grand Opening', emoji: '🎊', color: 'bg-rose-100 text-rose-700 border-rose-200' },
  { id: 'Exclusive Deal', name: 'Exclusive Deal', emoji: '👑', color: 'bg-slate-100 text-slate-700 border-slate-200' }
];

export const getOfferType = (type) => offerTypes.find(o => o.id === type) || offerTypes[0];

// Cities and Areas data structure
export const citiesData = {
  'Pune': {
    lat: 18.5204, lng: 73.8567,
    areas: [
      { id: 'fc-road', name: 'FC Road (Fergusson College Road)', lat: 18.5236, lng: 73.8408 },
      { id: 'mg-road', name: 'MG Road (Camp)', lat: 18.5147, lng: 73.8788 },
      { id: 'jm-road', name: 'JM Road', lat: 18.5308, lng: 73.8474 },
      { id: 'koregaon-park', name: 'Koregaon Park', lat: 18.5362, lng: 73.8930 },
      { id: 'viman-nagar', name: 'Viman Nagar', lat: 18.5679, lng: 73.9143 },
      { id: 'baner', name: 'Baner', lat: 18.5590, lng: 73.7868 },
      { id: 'aundh', name: 'Aundh', lat: 18.5580, lng: 73.8073 },
      { id: 'kalyani-nagar', name: 'Kalyani Nagar', lat: 18.5463, lng: 73.9020 },
      { id: 'laxmi-road', name: 'Laxmi Road', lat: 18.5146, lng: 73.8558 },
      { id: 'hadapsar', name: 'Hadapsar', lat: 18.5089, lng: 73.9260 },
      { id: 'shivajinagar', name: 'Shivajinagar', lat: 18.5308, lng: 73.8475 },
      { id: 'tulsi-baug', name: 'Tulsi Baug', lat: 18.5130, lng: 73.8560 },
      { id: 'swargate', name: 'Swargate', lat: 18.5018, lng: 73.8636 },
      { id: 'kothrud', name: 'Kothrud', lat: 18.5074, lng: 73.8077 },
      { id: 'bibwewadi', name: 'Bibwewadi', lat: 18.4772, lng: 73.8673 },
      { id: 'hinjewadi', name: 'Hinjewadi', lat: 18.5912, lng: 73.7380 },
      { id: 'wakad', name: 'Wakad', lat: 18.5912, lng: 73.7606 },
      { id: 'kharadi', name: 'Kharadi', lat: 18.5511, lng: 73.9407 },
      { id: 'magarpatta', name: 'Magarpatta', lat: 18.5158, lng: 73.9263 },
      { id: 'tathawade', name: 'Tathawade', lat: 18.6276, lng: 73.7465 }
    ]
  },
  'Mumbai': {
    lat: 19.0760, lng: 72.8777,
    areas: [
      { id: 'andheri', name: 'Andheri', lat: 19.1136, lng: 72.8697 },
      { id: 'bandra', name: 'Bandra', lat: 19.0596, lng: 72.8295 },
      { id: 'juhu', name: 'Juhu', lat: 19.1075, lng: 72.8263 },
      { id: 'powai', name: 'Powai', lat: 19.1176, lng: 72.9060 },
      { id: 'dadar', name: 'Dadar', lat: 19.0178, lng: 72.8478 },
      { id: 'kurla', name: 'Kurla', lat: 19.0726, lng: 72.8845 },
      { id: 'goregaon', name: 'Goregaon', lat: 19.1663, lng: 72.8526 },
      { id: 'malad', name: 'Malad', lat: 19.1874, lng: 72.8484 },
      { id: 'borivali', name: 'Borivali', lat: 19.2307, lng: 72.8567 },
      { id: 'thane', name: 'Thane', lat: 19.2183, lng: 72.9781 }
    ]
  },
  'Bangalore': {
    lat: 12.9716, lng: 77.5946,
    areas: [
      { id: 'koramangala', name: 'Koramangala', lat: 12.9352, lng: 77.6245 },
      { id: 'indiranagar', name: 'Indiranagar', lat: 12.9784, lng: 77.6408 },
      { id: 'whitefield', name: 'Whitefield', lat: 12.9698, lng: 77.7500 },
      { id: 'hsr-layout', name: 'HSR Layout', lat: 12.9116, lng: 77.6389 },
      { id: 'jayanagar', name: 'Jayanagar', lat: 12.9308, lng: 77.5838 },
      { id: 'electronic-city', name: 'Electronic City', lat: 12.8456, lng: 77.6603 },
      { id: 'marathahalli', name: 'Marathahalli', lat: 12.9591, lng: 77.6974 },
      { id: 'mg-road-blr', name: 'MG Road', lat: 12.9756, lng: 77.6066 },
      { id: 'jp-nagar', name: 'JP Nagar', lat: 12.9063, lng: 77.5857 },
      { id: 'hebbal', name: 'Hebbal', lat: 13.0358, lng: 77.5970 }
    ]
  },
  'Delhi': {
    lat: 28.7041, lng: 77.1025,
    areas: [
      { id: 'connaught-place', name: 'Connaught Place', lat: 28.6315, lng: 77.2167 },
      { id: 'karol-bagh', name: 'Karol Bagh', lat: 28.6514, lng: 77.1907 },
      { id: 'saket', name: 'Saket', lat: 28.5245, lng: 77.2066 },
      { id: 'rajouri-garden', name: 'Rajouri Garden', lat: 28.6492, lng: 77.1231 },
      { id: 'lajpat-nagar', name: 'Lajpat Nagar', lat: 28.5677, lng: 77.2433 },
      { id: 'south-extension', name: 'South Extension', lat: 28.5748, lng: 77.2224 },
      { id: 'dwarka', name: 'Dwarka', lat: 28.5921, lng: 77.0460 },
      { id: 'vasant-kunj', name: 'Vasant Kunj', lat: 28.5200, lng: 77.1500 },
      { id: 'rohini', name: 'Rohini', lat: 28.7495, lng: 77.0565 },
      { id: 'pitampura', name: 'Pitampura', lat: 28.7041, lng: 77.1318 }
    ]
  },
  'Hyderabad': {
    lat: 17.3850, lng: 78.4867,
    areas: [
      { id: 'hitech-city', name: 'HITEC City', lat: 17.4435, lng: 78.3772 },
      { id: 'gachibowli', name: 'Gachibowli', lat: 17.4401, lng: 78.3489 },
      { id: 'banjara-hills', name: 'Banjara Hills', lat: 17.4156, lng: 78.4347 },
      { id: 'jubilee-hills', name: 'Jubilee Hills', lat: 17.4326, lng: 78.4071 },
      { id: 'madhapur', name: 'Madhapur', lat: 17.4483, lng: 78.3915 },
      { id: 'kondapur', name: 'Kondapur', lat: 17.4593, lng: 78.3571 },
      { id: 'ameerpet', name: 'Ameerpet', lat: 17.4375, lng: 78.4483 },
      { id: 'kukatpally', name: 'Kukatpally', lat: 17.4849, lng: 78.3883 },
      { id: 'begumpet', name: 'Begumpet', lat: 17.4432, lng: 78.4678 },
      { id: 'secunderabad', name: 'Secunderabad', lat: 17.4399, lng: 78.4983 }
    ]
  },
  'Ahmedabad': {
    lat: 23.0225, lng: 72.5714,
    areas: [
      { id: 'cg-road', name: 'CG Road', lat: 23.0300, lng: 72.5600 },
      { id: 'sg-highway', name: 'SG Highway', lat: 23.0469, lng: 72.5120 },
      { id: 'prahlad-nagar', name: 'Prahlad Nagar', lat: 23.0134, lng: 72.5120 },
      { id: 'vastrapur', name: 'Vastrapur', lat: 23.0369, lng: 72.5294 },
      { id: 'satellite', name: 'Satellite', lat: 23.0169, lng: 72.5294 },
      { id: 'navrangpura', name: 'Navrangpura', lat: 23.0369, lng: 72.5600 },
      { id: 'bodakdev', name: 'Bodakdev', lat: 23.0469, lng: 72.5000 },
      { id: 'maninagar', name: 'Maninagar', lat: 22.9969, lng: 72.6000 },
      { id: 'gandhinagar', name: 'Gandhinagar', lat: 23.2156, lng: 72.6369 },
      { id: 'thaltej', name: 'Thaltej', lat: 23.0569, lng: 72.4994 },
      { id: 'law-garden', name: 'Law Garden', lat: 23.0269, lng: 72.5600 },
      { id: 'manek-chowk', name: 'Manek Chowk', lat: 23.0256, lng: 72.5833 },
      { id: 'bapunagar', name: 'Bapunagar', lat: 23.0469, lng: 72.6200 }
    ]
  },
  'Surat': {
    lat: 21.1702, lng: 72.8311,
    areas: [
      { id: 'vesu', name: 'Vesu', lat: 21.1456, lng: 72.7689 },
      { id: 'adajan', name: 'Adajan', lat: 21.1869, lng: 72.7894 },
      { id: 'varachha', name: 'Varachha', lat: 21.2069, lng: 72.8694 },
      { id: 'athwa', name: 'Athwa', lat: 21.1769, lng: 72.8094 },
      { id: 'katargam', name: 'Katargam', lat: 21.2169, lng: 72.8394 },
      { id: 'dumas', name: 'Dumas', lat: 21.0869, lng: 72.7094 },
      { id: 'piplod', name: 'Piplod', lat: 21.1569, lng: 72.7794 },
      { id: 'citylight', name: 'Citylight', lat: 21.1669, lng: 72.7994 },
      { id: 'pal', name: 'Pal', lat: 21.1369, lng: 72.7594 },
      { id: 'sagrampura', name: 'Sagrampura', lat: 21.1969, lng: 72.8294 },
      { id: 'ring-road', name: 'Ring Road', lat: 21.1702, lng: 72.8100 }
    ]
  },
  'Indore': {
    lat: 22.7196, lng: 75.8577,
    areas: [
      { id: 'vijay-nagar', name: 'Vijay Nagar', lat: 22.7533, lng: 75.8937 },
      { id: 'sapna-sangeeta', name: 'Sapna Sangeeta', lat: 22.7296, lng: 75.8677 },
      { id: 'palasia', name: 'Palasia', lat: 22.7196, lng: 75.8477 },
      { id: 'rajwada', name: 'Rajwada', lat: 22.7178, lng: 75.8545 },
      { id: 'bhawarkua', name: 'Bhawarkua', lat: 22.7096, lng: 75.8377 },
      { id: 'treasure-island', name: 'Treasure Island', lat: 22.7396, lng: 75.8777 },
      { id: 'sudama-nagar', name: 'Sudama Nagar', lat: 22.6996, lng: 75.8677 },
      { id: 'rau', name: 'Rau', lat: 22.6496, lng: 75.8177 },
      { id: 'mhow', name: 'Mhow', lat: 22.5496, lng: 75.7577 },
      { id: 'nipania', name: 'Nipania', lat: 22.7696, lng: 75.9177 },
      { id: 'sarafa-bazaar', name: 'Sarafa Bazaar', lat: 22.7196, lng: 75.8577 }
    ]
  },
  'Nagpur': {
    lat: 21.1458, lng: 79.0882,
    areas: [
      { id: 'dharampeth', name: 'Dharampeth', lat: 21.1458, lng: 79.0582 },
      { id: 'sitabuldi', name: 'Sitabuldi', lat: 21.1458, lng: 79.0782 },
      { id: 'sadar', name: 'Sadar', lat: 21.1558, lng: 79.0882 },
      { id: 'ramdaspeth', name: 'Ramdaspeth', lat: 21.1358, lng: 79.0682 },
      { id: 'civil-lines', name: 'Civil Lines', lat: 21.1658, lng: 79.0982 },
      { id: 'manish-nagar', name: 'Manish Nagar', lat: 21.1158, lng: 79.0482 },
      { id: 'lakadganj', name: 'Lakadganj', lat: 21.1758, lng: 79.1082 },
      { id: 'wardha-road', name: 'Wardha Road', lat: 21.1058, lng: 79.0282 },
      { id: 'pratap-nagar', name: 'Pratap Nagar', lat: 21.1258, lng: 79.1182 },
      { id: 'koradi', name: 'Koradi', lat: 21.2058, lng: 79.1382 },
      { id: 'itwari', name: 'Itwari', lat: 21.1508, lng: 79.0832 }
    ]
  },
  'Jaipur': {
    lat: 26.9124, lng: 75.7873,
    areas: [
      { id: 'malviya-nagar', name: 'Malviya Nagar', lat: 26.8524, lng: 75.8073 },
      { id: 'vaishali-nagar', name: 'Vaishali Nagar', lat: 26.9124, lng: 75.7273 },
      { id: 'mansarovar', name: 'Mansarovar', lat: 26.8724, lng: 75.7573 },
      { id: 'c-scheme', name: 'C-Scheme', lat: 26.9024, lng: 75.7873 },
      { id: 'raja-park', name: 'Raja Park', lat: 26.9224, lng: 75.8073 },
      { id: 'tonk-road', name: 'Tonk Road', lat: 26.8624, lng: 75.7973 },
      { id: 'jagatpura', name: 'Jagatpura', lat: 26.8424, lng: 75.8473 },
      { id: 'sodala', name: 'Sodala', lat: 26.9024, lng: 75.7673 },
      { id: 'bani-park', name: 'Bani Park', lat: 26.9324, lng: 75.7773 },
      { id: 'jhotwara', name: 'Jhotwara', lat: 26.9424, lng: 75.7473 },
      { id: 'johari-bazaar', name: 'Johari Bazaar', lat: 26.9224, lng: 75.8233 },
      { id: 'bapu-bazaar', name: 'Bapu Bazaar', lat: 26.9174, lng: 75.8173 },
      { id: 'mi-road', name: 'MI Road', lat: 26.9124, lng: 75.7973 }
    ]
  }
};

// Export cities list with "Other" option at the end
export const cities = [...Object.keys(citiesData), 'Other'];
export const getAreasForCity = (city) => citiesData[city]?.areas || [];

// UPI and Payment constants
export const UPI_ID = '9970610200-2@ybl';
export const PAYEE_NAME = 'JustOffs India';
export const WHATSAPP_NUMBER = '447831230648';
export const FEATURED_AMOUNT = 499;
export const QR_IMAGE_URL = 'https://customer-assets.emergentagent.com/job_shopconnect-40/artifacts/9loj27nv_image.png';
